module.exports = "/_next/static/images/devOps-2x-6b30dc8707c0549986e84796f63d6c46.jpg.webp";